export default "__VITE_ASSET__Cu31hr4G__"